import { render } from "./kbinfo.vue?vue&type=template&id=e013186a"
import script from "./kbinfo.vue?vue&type=script&lang=js"
export * from "./kbinfo.vue?vue&type=script&lang=js"

import "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css"
import "./kbinfo.vue?vue&type=style&index=1&id=e013186a&lang=css"

import exportComponent from "E:\\mydemo\\issue-security-vue\\issuebye-fore\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__